// Import the functions you need from the SDKs you need
//import { initializeApp } from "firebase/app";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD0CM4J3doIB-UYZ2AsAXLaKsa2MWpEvQ4",
  authDomain: "crypto-world-86cfc.firebaseapp.com",
  projectId: "crypto-world-86cfc",
  storageBucket: "crypto-world-86cfc.appspot.com",
  messagingSenderId: "1053445340910",
  appId: "1:1053445340910:web:63bda57c054742c9933dff"
};

export default firebaseConfig;
